var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "sui-container",
    { staticClass: "investment-strategy-form" },
    [
      _c("h3", { staticStyle: { "font-weight": "lighter" } }, [
        _vm._v("New Investment Strategy"),
      ]),
      _c("InvestmentStrategyForm", { ref: "form" }),
      _c(
        "div",
        [
          _c("sui-button", {
            attrs: {
              basic: "",
              color: "grey",
              type: "button",
              content: "Cancel",
            },
            nativeOn: {
              click: function ($event) {
                return _vm.cancel.apply(null, arguments)
              },
            },
          }),
          _c("sui-button", {
            attrs: { primary: "", type: "button", content: "Submit" },
            nativeOn: {
              click: function ($event) {
                return _vm.save.apply(null, arguments)
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }